import { useMutation } from '@tanstack/react-query';
import { ClinicMasterProduct } from '../types';
import { createClinicMasterProduct } from '../requests';

type CreateClinicMasterProduct = (data: ClinicMasterProduct) => Promise<ClinicMasterProduct>;

interface UseCreateClinicMasterProductReturn {
  createClinicMasterProduct: CreateClinicMasterProduct;
  isLoading: boolean;
}

export const useCreateClinicMasterProduct = (): UseCreateClinicMasterProductReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (clinicMasterProduct: ClinicMasterProduct) => createClinicMasterProduct(clinicMasterProduct)
  });

  const createClinicMasterProductCallback = async (clinicMasterProduct: ClinicMasterProduct) => {
    const response = await mutateAsync(clinicMasterProduct);
    return response.data.data;
  };

  return {
    createClinicMasterProduct: createClinicMasterProductCallback,
    isLoading
  };
};
